/**
 * List Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.controller('ImportIndexController', [
    '$scope',
    '$window',
    '$timeout',
    'importApi',
    function($scope, $window, $timeout, importApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.list = null;
      $scope.importMessage = null;
      $scope.filenames = null;

      $scope.page = {
        number: 0,
        size: 100,
      };

      $scope.searchTerm = '';
      $scope.loading = false;

      $scope.sort = {
        field: 'id',
        order: 'desc',
      };

      $scope.importDisabled = true;
      $scope.import2Disabled = false;

      var filterTimeout = null;
      $scope.$watch('searchTerm', function(newVal, oldVal) {
        if (newVal == oldVal) {
          return;
        }

        if (filterTimeout) {
          $timeout.cancel(filterTimeout);
        }

        filterTimeout = $timeout(function() {
          $scope.page.number = 0;

          $scope.fetch();
        }, 700);
      });

        $scope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
                if(fn && (typeof(fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };


        $scope.setFileNameList = function(files) {
            $scope.safeApply(() => {
                if (!files.length) {
                    $scope.filenames = 'Nothing selected';
                    $scope.importDisabled = true;
                } else {
                    $scope.filenames = files.join(", ");
                    $scope.importDisabled = false;
                }
            });

            console.log("setFileNameList: " + $scope.importDisabled);
        };

      $scope.fileNameChanged = function(object){
          console.log($(object));
          var filenames = [];
          for (var i = 0; i < $(object).get(0).files.length; i++) {
            filenames.push($(object).get(0).files[i].name);
          }
          $scope.setFileNameList(filenames);
      };


        // try saving and process server side validation errors
        $scope.submitForm = function() {
            console.log("submitForm");
            if ($scope.importDisabled) {
                return;
            }
            $scope.setFileNameList([]);

            $scope.error = false;
            var files = document.getElementById('file').files;
            console.log(files);
            var formData = new FormData();
            for (var i = 0; i < files.length; i++) {
                formData.append('file[]', files[i]);
            }

            importApi.import(formData).then(
                function(data) {
                    $scope.importMessage = data.message;
                    //$window.location.href = '/#!/demandmgr/import';
                    $scope.fetch();
                },
                function(message) {
                    $scope.error = true;
                    $scope.importMessage = message;
                }
            );
        };

      $scope.getStatus = function(status) {
        return status ? 'Active' : 'Inactive';
      };

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;

        importApi.getList($scope.sort, $scope.searchTerm, $scope.page).then(
          function(data) {
            $scope.list = {
              count: data.count,
              data: data.data,
              maxPage: Math.floor(data.count / $scope.page.size),
            };
            $scope.loading = false;
          },
          function() {
            $scope.list = {
              count: 0,
              data: [],
              maxPage: null,
            };
            $scope.loading = false;
          }
        );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      $scope.showLog = function(id) {
          importApi.getDetails(id).then(
              function(data) {
                  data = data.replaceAll("\n", '<br/>');
                  data = data.replaceAll(/(error)/ig, '<span style="color: red">$1</span>');
                  data = data.replaceAll(/(warning)/ig, '<span style="color: yellow">$1</span>');

                  $('#import-info-modal #import_info_title').text("ID:" + id);
                  $('#import-info-modal #log').html(data);

                  $('#import-info-modal').modal('show');
              },
              function() {
              }
          );
      };


      $scope.startImport = function(id) {
          var formData = new FormData();
          formData.append('id', id);
          formData.append('importType', 2); // 1 = DRY_RUN 2 = IMPORT
          $scope.import2Disabled = true;
          importApi.import(formData).then(
              function(data) {
                  $scope.import2Disabled = false;
                  $scope.importMessage = data.message;
                  $scope.fetch();
              },
              function(message) {
                  $scope.import2Disabled = false;
                  alert(message);
                  $scope.error = true;
                  $scope.importMessage = message;
              }
          );
      };

      $scope.setFileNameList([]);
      $scope.fetch();
    },
  ]);
})(window.angular);

